module.exports = __webpack_public_path__ + "img/cktw1.e8a9b230.jpeg";